import { useEffect, useRef } from "react";
import { useFormModal } from "@/react/components/FormRendererV2/FormModal";
import { useFormRenderingContext } from "../contexts/FormRenderingContext";
import { useModalCookie } from "../hooks/useModalCookie";

export const useModalCountdown = () => {
  const formRenderingContextValue = useFormRenderingContext();
  const { form, index, popupDelay } = formRenderingContextValue;
  const formModal = useFormModal();
  const { shouldSuppressPopupForm } = useModalCookie();
  const hasShownModal = useRef(false);

  useEffect(() => {
    if (shouldSuppressPopupForm || hasShownModal.current) return;

    const delayMs = Math.max(0, Number(popupDelay ?? 0)) * 1000;

    const timer = setTimeout(() => {
      // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
      window.parent.postMessage(
        {
          type: "resize",
          formUid: form.uid,
          formIndex: index,
          height: "100vh",
        },
        "*",
      );
      hasShownModal.current = true;
      void formModal.show({ formRenderingContextValue });
    }, delayMs);

    return () => clearTimeout(timer);
  }, [
    shouldSuppressPopupForm,
    popupDelay,
    form.uid,
    index,
    formModal,
    formRenderingContextValue,
  ]);
};
